var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 74,
    viewBox: "0 0 76 74",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 20.0586,
    width: 12.6667,
    height: 42.3529,
    rx: 0.5,
    fill: "#39C5CA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 63.3334,
    y: 7.35254,
    width: 12.6667,
    height: 42.3529,
    rx: 0.5,
    fill: "#39C5CA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.2222,
    y: 15.8232,
    width: 12.6667,
    height: 21.1765,
    rx: 0.5,
    fill: "#39C5CA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1111,
    y: 37,
    width: 12.6667,
    height: 21.1765,
    rx: 0.5,
    fill: "#39C5CA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33331 9.4707L6.33331 73.0001",
    stroke: "#39C5CA",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6666 1V58.1765",
    stroke: "#39C5CA",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5555 9.4707V43.3531",
    stroke: "#39C5CA",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4445 30.6475V64.5298",
    stroke: "#39C5CA",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon8.609cf1075dd272395629a04324e7d893.svg";
export { ForwardRef as ReactComponent };